<template>
  <RevCard class="p-24">
    <div class="flex justify-between flex-col gap-24 h-full">
      <div class="space-y-24">
        <div class="space-y-8">
          <div class="flex items-center gap-8">
            <slot name="logo" />

            <p class="body-1-bold">
              {{ name }}
            </p>
          </div>

          <div class="flex items-center gap-4">
            <RevRating :score="trustpilotRating" size="extra-small" />

            <span class="text-static-default-low caption">
              {{ i18n(translations.onTrustpilot) }}
            </span>
          </div>
        </div>

        <div>
          <p class="text-static-default-low caption">
            {{ i18n(translations.startingAt) }}
          </p>

          <p class="heading-2 space-x-4">
            <span>{{ price }}</span>

            <span v-if="formerPrice" class="line-through">
              {{ formerPrice }}
            </span>

            <span>{{ i18n(translations.priceSuffix) }}</span>
          </p>
        </div>

        <slot name="info" />

        <ul class="space-y-12">
          <li
            v-for="benefit in benefits"
            :key="benefit"
            class="flex items-start gap-8"
          >
            <IconCheckSmall
              class="-top-2 relative text-static-brand-mid mt-2 shrink-0"
              size="20"
            />

            <span class="body-2">{{ benefit }}</span>
          </li>
        </ul>
      </div>

      <RevDialog :name="dialogName" :title="i18n(translations.modalTitle)">
        <template #trigger="{ open }">
          <RevButton full-width="always" variant="primary" @click="open">
            {{ i18n(translations.getStarted) }}
          </RevButton>
        </template>

        <template #body>
          <slot name="modal" />
        </template>
      </RevDialog>
    </div>
  </RevCard>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevCard } from '@ds/components/Card'
import { RevDialog } from '@ds/components/Dialog'
import { RevRating } from '@ds/components/Rating'
import { IconCheckSmall } from '@ds/icons/IconCheckSmall'

import translations from './OfferComparisonCard.translations'

defineProps<{
  dialogName: string
  name: string
  trustpilotRating: number
  price: string
  formerPrice?: string
  benefits: string[]
}>()

defineSlots<{
  logo?: () => unknown
  info?: () => unknown
  modal?: () => unknown
}>()

const i18n = useI18n()
</script>
